/* eslint-disable @nrwl/nx/enforce-module-boundaries */
import { commonApi, marketingProductApi } from '@shared/apis';
import { useUserStore } from '@shared/store';
import { defineStore } from 'pinia';
import { getQueryString } from '@shared/utils';

type StateType = {
  isShowSpecialText?: boolean;
  attributionValue: string;
  isZX: boolean;
  zxBankOrgInfo: any;
  validCorpList: string[];
};

export const useProductCommonStore = defineStore('productCommonStore', {
  state: (): StateType => {
    return {
      isShowSpecialText: undefined, // 是否显示 '热销产品'
      attributionValue: '',
      isZX: false,
      zxBankOrgInfo: undefined, // 中信业绩归属-获取员工对应机构信息
      validCorpList: [],
    };
  },
  actions: {
    async getFinancialProductIncomeConfigAction() {
      try {
        if (this.isShowSpecialText !== undefined) return this.isShowSpecialText;
        const userStore = useUserStore();
        const params = {
          config: 'product_performance_attribution_parameter',
          staffId: userStore.viewStaffInfo.staffId,
        };
        const { retdata } = await marketingProductApi.getFinancialProductIncomeConfigApi(params);
        this.isShowSpecialText = retdata.hasConfig;
      } catch (error) {
        console.error('%c getFinancialProductIncomeConfigApi error:', 'color: #fff;background: #b457ff;', error);
        return {};
      }
    },
    async getCustomParamsAction() {
      try {
        const { retdata } = await marketingProductApi.getCustomParamsApi({ type: 3 });
        this.attributionValue = retdata?.value || '';
      } catch (error) {
        console.error('%c getCustomParamsApi error:', 'color: #fff;background: #b457ff;', error);
        return {};
      }
    },
    async getZxBankOrgInfoAction() {
      const userStore = useUserStore();
      const corpIdArray = ['ww759a9d253baff265']; // 中信
      let currentCorpId = getQueryString('currentCorpId') || '';
      if (currentCorpId) {
        sessionStorage.setItem('currentCorpId', currentCorpId);
      } else {
        currentCorpId = sessionStorage.getItem('currentCorpId') || '';
      }
      this.isZX = corpIdArray.includes(currentCorpId);
      if (!this.isZX) return;

      const zhEncryptUserInfo = decodeURI(getQueryString('extendData') || '');
      const zhOrgName = decodeURI(getQueryString('zhOrgname') || '');
      const zhOrgNo = decodeURI(getQueryString('zhOrgno') || '');
      const fhOrgName = decodeURI(getQueryString('fhOrgname') || '');
      const fhOrgNo = decodeURI(getQueryString('fhOrgno') || '');

      if (zhEncryptUserInfo || zhOrgName || zhOrgNo || fhOrgName || fhOrgNo) {
        try {
          await marketingProductApi.saveBankOrgInfoApi({
            encryptUserInfo: zhEncryptUserInfo,
            zhOrgName: zhEncryptUserInfo ? '' : zhOrgName,
            zhOrgNo: zhEncryptUserInfo ? '' : zhOrgNo,
            fhOrgName: zhEncryptUserInfo ? '' : fhOrgName,
            fhOrgNo: zhEncryptUserInfo ? '' : fhOrgNo,
          });
          if (zhEncryptUserInfo) {
            this.zxBankOrgInfo = { encryptUserInfo: zhEncryptUserInfo } as any;
          } else {
            this.zxBankOrgInfo = { zhOrgName, zhOrgNo, fhOrgName, fhOrgNo } as any;
          }
        } catch (err) {
          console.log('err', err);
        }
      } else if (!this.zxBankOrgInfo) {
        try {
          const { retdata } = await marketingProductApi.getBankOrgInfoApi({
            corpId: currentCorpId,
            staffId: userStore.viewStaffInfo?.staffId,
          });
          this.zxBankOrgInfo = retdata || {};
        } catch (err) {
          console.log('err', err);
        }
      }
    },

    // 获取配置了营销机会应用的公司ID列表
    async getValidCorpListAction() {
      if (this.validCorpList.length > 0) return this.validCorpList;
      try {
        const { retdata = [] } = await commonApi.getValidCorpListApi();
        // 已经购买了sop推送服务的企业id
        this.validCorpList = retdata;
        return retdata;
      } catch (err: any) {
        console.error('validCorpList', err);
      }
    },
  },
});
